import React from 'react';
import styles from './AddEditHeader.module.scss';
import floppyIcon from '../../../assets/Imagess/floppy-white.svg';
import draftIcon from '../../../assets/Imagess/draft.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import BackIcon from '../../../assets/Imagess/BackIcon.svg';

const CreateNewsHeader = ({
  handleSubmit,
  title,
  setAddEditMode,
  moveRight,
}) => {
  return (
    <div className={styles['add-programs-header']}>
      <div>
        <p className={styles['title']}>
          {/* <img
            src={BackIcon}
            className={styles["BackIcon"]}
            onClick={() => setAddEditMode(false)}
            alt={""}
          /> */}
          <span>{title}</span>
        </p>
      </div>
      <div className={styles['icon-subcontainer']}>
        <Buttons
          text="حفظ"
          icon={floppyIcon}
          rounded={true}
          color="rgba(13, 160, 110, 1)"
          handleOnClick={() => handleSubmit()}
          style={{ fontFamily: 'BukraMedium' }}
        />
      </div>
    </div>
  );
};

export default CreateNewsHeader;
